import script from "./ThemeSwitcher.vue?vue&type=script&setup=true&lang=js"
export * from "./ThemeSwitcher.vue?vue&type=script&setup=true&lang=js"

import "./ThemeSwitcher.vue?vue&type=style&index=0&id=0776dd2c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0776dd2c"]])

export default __exports__